import React from 'react';
import {SvgIcon} from '../../icons/svgIcon';
import {IconType} from '../../icons/icons';
import classNames from 'clsx';
import './hibuButton.scss';
import {HibuTooltip} from '../hibuTooltip/hibuTooltip';

type InputProps = {
    visible: boolean;
    className?: string;
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    icon: IconType;
    tooltipKey?: string;
    size?: 'sm' | 'md';
    disabled?: boolean;
    placement?: any;
    label?: string;
    classNameIcon?: string;
    altText?: string;
};

export const HibuButton = React.memo(
    ({
        visible,
        className,
        onClick,
        icon,
        tooltipKey,
        size,
        disabled,
        placement,
        label,
        classNameIcon,
        altText,
    }: InputProps) => {
        if (!visible) {
            return null;
        }

        const hibuButton = (
            <button
                className={classNames('hibu-button', className, size || 'md')}
                onClick={(e) => onClick(e)}
                disabled={disabled}
            >
                <SvgIcon icon={icon} className={classNameIcon} alt={altText} />
                {label}
            </button>
        );

        if (tooltipKey) {
            return (
                <HibuTooltip tooltipKey={tooltipKey} placement={placement}>
                    {hibuButton}
                </HibuTooltip>
            );
        }

        return hibuButton;
    },
);
